import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImagegridComponent } from './imagegrid.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    ImagegridComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ImagegridComponent
  ]
})
export class ImagegridModule { }
